/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sourcechat1Inputs */

const en_sourcechat1 = /** @type {(inputs: Sourcechat1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`chat`)
};

const pt_sourcechat1 = /** @type {(inputs: Sourcechat1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`chat`)
};

/**
* | output |
* | --- |
* | "chat" |
*
* @param {Sourcechat1Inputs} inputs
* @param {{ locale?: "en" | "pt" }} options
* @returns {LocalizedString}
*/
const sourcechat1 = /** @type {((inputs?: Sourcechat1Inputs, options?: { locale?: "en" | "pt" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sourcechat1Inputs, { locale?: "en" | "pt" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_sourcechat1(inputs)
	return pt_sourcechat1(inputs)
});
export { sourcechat1 as "sourceChat" }